import React from 'react';
import { Config } from '@leverege/plugin';
import { Pane, CompositeTextInput, Button, Dialogs, Text } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import Molten from '@leverege/molten';
import { GlobalState } from '@leverege/ui-redux';
import withContexts from './withContexts';
import Loading from '../../../components/Loading';
import Scanner from './Scanner';
import { isVIN, normalizeVIN, ignoreNonVINCharacterEvent, removeNonVINCharacters } from '../../../util/VIN';
import ConfirmVinCollisionDialog from './ConfirmVinCollisionDialog';
import S from './VinEditor.css';
import { getCompanyAndLocationIdsFromUrl } from '../../../util/Url';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const imageOpts = {
  style: {
    width: '16px',
    height: '16px'
  }
};
class VinEditor extends React.Component {
  constructor(props) {
    super(props);
    const {
      object
    } = props;
    const locationId = Attributes.get('vehicle.location', 'vehicle', object.data);
    const consumerLocationId = Config.get('ConsumerLocation', 'id');
    let networkKey;
    if (locationId === consumerLocationId) {
      networkKey = 'VehicleNetwork.consumer';
    } else {
      networkKey = 'VehicleNetwork.dealer';
    }
    this.networkId = Config.get(networkKey, 'id');
    this.state = {
      loading: false,
      scanning: false
    };
  }
  componentDidMount() {
    const {
      context,
      onChange,
      eventData
    } = this.props;
    const value = this.getValue();
    const pairing = context.clientProps?.pairing;
    if (value && pairing) {
      onChange({
        data: 'header/networkId',
        value: this.networkId
      });
      this.onChange({
        data: eventData,
        value
      });
    }
  }
  getValue() {
    const {
      value
    } = this.props;
    return value;
  }
  onImage = ({
    value,
    data
  }) => {
    const code = Array.isArray(value) ? value[0].text : value.text;
    if (!isVIN(code)) {
      return;
    }
    this.onChange({
      value: normalizeVIN(code),
      data
    });
    this.onToggleScanner();
  };
  onScan = ({
    value,
    data
  }) => {
    const {
      codeResult: {
        code
      }
    } = value;
    if (!isVIN(code)) {
      return;
    }
    this.onChange({
      value: normalizeVIN(code),
      data
    });
    this.onToggleScanner();
  };
  onToggleScanner = () => {
    this.setState(prevState => ({
      scanning: !prevState.scanning
    }));
  };
  onChange = async evt => {
    const {
      onChange,
      eventData
    } = this.props;

    // eslint-disable-next-line no-param-reassign
    const value = removeNonVINCharacters(evt?.value?.toUpperCase?.());
    const decoded = await this.decodeVIN(value, true);
    const changeData = {
      [eventData]: eventData
    };
    const change = {
      [eventData]: value
    };
    if (decoded) {
      Object.entries(decoded).forEach(([key, value]) => {
        if (key === 'vin') {
          return;
        }
        let nValue = value.trim();
        if (key === 'year') {
          nValue = parseInt(nValue);
        }
        change[`vehicle.${key}`] = nValue;
        changeData[`vehicle.${key}`] = `vehicle.${key}`;
      });
    }
    onChange({
      data: changeData,
      value: change
    });
  };

  // TODO: fix up validation
  setError(err) {
    this.setState({
      error: err
    });
  }
  decodeVIN = async (vin, force = false) => {
    // return
    if (!vin) {
      return null;
    }
    this.setState({
      loading: true
    });
    const {
      api
    } = this.props;
    const projectId = api.options.projectId;
    let companyId, locationId;
    try {
      const currentPath = GlobalState.get().router?.location.pathname;
      const companyLocationId = getCompanyAndLocationIdsFromUrl(currentPath);
      companyId = companyLocationId.companyId;
      locationId = companyLocationId.locationId;
      const postData = {
        vin
      };
      const systemId = Molten.getConfig('api/systemId');
      let apiTarget;
      if (locationId) {
        if (companyId) {
          apiTarget = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId);
        } else {
          apiTarget = api.interface(systemId, 'location').obj(locationId);
        }
        await apiTarget.srv('recovrVin').post('checkVinConflict', postData);
      }
    } catch (error) {
      Dialogs.show({
        component: ConfirmVinCollisionDialog,
        props: {
          ...this.props,
          api,
          vin,
          errorCode: error.reason,
          existingVehicleLocation: {
            name: error.vehicleLocationName,
            id: error.vehicleLocationId
          },
          saleData: error.saleData,
          locationId,
          companyId
        }
      });
    } finally {
      this.setState({
        loading: false
      });
    }
    try {
      const res = await api.child(`v1/project/${projectId}/srv/vin/${vin}`).get();
      this.setError(null);
      return res.result;
    } catch (err) {
      console.error(err);
      let error = 'Error decoding VIN, please verify that the VIN you have entered is correct.';
      if (err.status === 404) {
        error = 'VIN not found. The entered VIN could not be decoded. Please enter VIN details manually.';
      }
      this.setError(error);
    } finally {
      this.setState({
        loading: false
      });
    }
    return null;
  };
  render() {
    const {
      loading,
      scanning
    } = this.state;
    const {
      eventData
    } = this.props;
    const {
      error
    } = this.state;
    return /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colS",
      children: [/*#__PURE__*/_jsx(CompositeTextInput, {
        className: S.input,
        eventData: eventData,
        value: this.getValue(),
        onChange: this.onChange,
        onKeyDown: ignoreNonVINCharacterEvent,
        post: /*#__PURE__*/_jsx(Button, {
          icon: "https://recovr-ui-assets.storage.googleapis.com/camera.png",
          imageOpts: imageOpts,
          onClick: this.onToggleScanner,
          variant: "pairCamera|tertiarySmallIconic"
        })
      }), error && /*#__PURE__*/_jsx(Text, {
        icon: "fa fa-fw fa-exclamation-triangle",
        variant: "inputCaptionSmallError",
        children: error
      }), /*#__PURE__*/_jsx(Loading, {
        message: "VIN Processing",
        loading: loading
      }), /*#__PURE__*/_jsx(Scanner, {
        eventData: eventData,
        open: scanning,
        onScan: this.onScan,
        onImage: this.onImage,
        onClose: this.onToggleScanner
      })]
    });
  }
}
const VinEditorWithContexts = withContexts(VinEditor);
export { VinEditor, VinEditorWithContexts };
export default VinEditorWithContexts;